import React from 'react';

export default function ReactorTankIcon({
  width = 64,
  height = 55,
  startColor = '#1E1E1E',
  midColor = '#FFFFFF',
  endColor = '#1E1E1E'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 112.5 96.055" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_TankBody">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="53.8853" y1="65.5383" x2="53.8853" y2="4.6179">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.45" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.76" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.77" style={{stopColor: "#A5A5A5"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M9.349,4.617c-5.488,0-9.347,13.638-9.347,30.46s3.858,30.46,9.347,30.46h98.42V4.617H9.349z" />
	<ellipse fill="#7E7E7E" cx="107.769" cy="35.022" rx="2.364" ry="30.404" />
</g>
<g id="Group_TankSupprt">
	<path fill="#3A3A3A" d="M13.965,65.538h86.822v7.095H13.965V65.538z" />
	<path d="M18.695,72.633h77.362v16.328H18.695V72.633z" fill="#FFFFFF" />
	<path fill="#545454" d="M16.33,84.344h42.229v9.347H16.33V84.344z" />
	<path fill="#3A3A3A" d="M56.194,86.708h46.845v9.347H56.194V86.708z" />
	<path fill="#ACACAC" d="M53.829,93.691h51.575v2.364H53.829V93.691z" />
	<path fill="#ACACAC" d="M53.829,86.708h51.575v2.365H53.829V86.708z" />
</g>
<g id="Group_Support">
	<path fill="#A5A5A5" d="M58.559,63.286h6.981v13.963h-6.981V63.286z" />
	<path fill="#A5A5A5" d="M21.06,63.286h6.982v13.963H21.06V63.286z" />
	<path fill="#9F9F9F" d="M13.965,77.249h21.17v7.095h-21.17V77.249z" />
	<path fill="#C7C7C7" d="M42.118,77.249h44.593v9.459H42.118V77.249z" />
	<path fill="#7E7E7E" d="M39.753,70.268h7.094v14.076h-7.094V70.268z" />
	<path fill="#4B4B4B" d="M13.965,79.615h21.17v2.364h-21.17V79.615z" />
</g>
<g id="Group_Lines">
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="10.5308" y1="67.9026" x2="10.5308" y2="2.2527">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M9.349,2.252h2.365v65.65H9.349V2.252z" />
	<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="19.8774" y1="67.9026" x2="19.8774" y2="2.2527">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} d="M18.695,2.252h2.365v65.65h-2.365V2.252z" />
	<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="29.2241" y1="67.9026" x2="29.2241" y2="2.2527">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_4_)`} d="M28.042,2.252h2.365v65.65h-2.365V2.252z" />
	<linearGradient id={`${id}_5_`} gradientUnits="userSpaceOnUse" x1="38.6265" y1="67.9026" x2="38.6265" y2="2.2527">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_5_)`} d="M37.5,2.252h2.252v65.65H37.5V2.252z" />
	<linearGradient id={`${id}_6_`} gradientUnits="userSpaceOnUse" x1="48.0298" y1="67.9026" x2="48.0298" y2="2.2527">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_6_)`} d="M46.847,2.252h2.365v65.65h-2.365V2.252z" />
	<linearGradient id={`${id}_7_`} gradientUnits="userSpaceOnUse" x1="57.376" y1="67.9026" x2="57.376" y2="2.2527">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_7_)`} d="M56.194,2.252h2.365v65.65h-2.365V2.252z" />
	<linearGradient id={`${id}_8_`} gradientUnits="userSpaceOnUse" x1="66.7227" y1="67.9026" x2="66.7227" y2="2.2527">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_8_)`} d="M65.54,2.252h2.364v65.65H65.54V2.252z" />
	<linearGradient id={`${id}_9_`} gradientUnits="userSpaceOnUse" x1="76.126" y1="67.9026" x2="76.126" y2="2.2527">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_9_)`} d="M75,2.252h2.252v65.65H75V2.252z" />
	<linearGradient id={`${id}_10_`} gradientUnits="userSpaceOnUse" x1="85.5283" y1="67.9026" x2="85.5283" y2="2.2527">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_10_)`} d="M84.346,2.252h2.365v65.65h-2.365V2.252z" />
	<linearGradient id={`${id}_11_`} gradientUnits="userSpaceOnUse" x1="94.875" y1="67.9026" x2="94.875" y2="2.2527">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_11_)`} d="M93.692,2.252h2.364v65.65h-2.364V2.252z" />
	<linearGradient id={`${id}_12_`} gradientUnits="userSpaceOnUse" x1="104.2217" y1="67.9026" x2="104.2217" y2="2.2527">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_12_)`} d="M103.039,2.252h2.365v65.65h-2.365V2.252z" />
</g>
<g id="Group_Label">
	<path fill="#AAAAAA" d="M81.98,23.423h18.807v11.711H81.98V23.423z" />
	<path fill="#F0F0F0" d="M96.057,23.423v2.364H84.346v6.981h11.711v2.365H81.98V23.423H96.057z" />
</g>
<g id="Group_Tank_Valves1">
	<path d="M25.001,1.464v3.153h1.464V1.464h1.577V0h-4.617v1.464H25.001z" fill="#FFFFFF" />
	<path d="M88.287,1.464v3.153h1.576V1.464h1.465V0h-4.617v1.464H88.287z" fill="#FFFFFF" />
</g>
<g id="Group_Tank_Valves2">
	<path fill="#E4E4E4" d="M110.922,13.288h-3.153c0,0-0.347,0.731,0,1.464h3.153v1.576h1.576v-4.617h-1.576V13.288z" />
	<path fill="#E4E4E4" d="M110.922,55.404h-3.153c0,0-0.253,0.702,0,1.576h3.153v1.577h1.576v-4.729h-1.576V55.404z" />
</g>
    
      </g>
      <rect x="0" y="0" width="112.5" height="96.055" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
